import { Box, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import {
  Illustration,
  LoadingSpinner,
  Text,
  Title,
} from "@src/appV2/redesign/system/ui-components";
import { getSafeAreaPaddings } from "@src/appV2/redesign/utils/getSafeAreaPaddings";

export interface IncompleteStripeSetupPageContentProps {
  isCompleteStripeSetupLoading: boolean;
  onCompleteStripeSetupClick: () => void;
}

export function IncompleteStripeSetupPageContent(props: IncompleteStripeSetupPageContentProps) {
  const { isCompleteStripeSetupLoading, onCompleteStripeSetupClick } = props;

  return (
    <Stack
      sx={(theme) => ({
        flex: 1,
        paddingX: theme.spacing(5),
        paddingTop: theme.spacing(10),
        ...getSafeAreaPaddings({ bottom: true, fallbackBottom: theme.spacing(6) }),
      })}
    >
      <Stack spacing={8} sx={{ alignItems: "center" }}>
        <Illustration type="instant-pay-warning" />
        <Stack spacing={5}>
          <Title variant="h3" component="h3" sx={{ textAlign: "center" }}>
            Your Stripe account setup is incomplete
          </Title>
          <Text
            variant="body2"
            sx={(theme) => ({
              textAlign: "center",
              marginTop: theme.spacing(3),
              color: theme.palette.text.secondary,
            })}
          >
            You won&apos;t be able to receive payments until you finish setting up your Stripe
            account.
          </Text>
        </Stack>
      </Stack>

      <Box sx={{ flex: 1 }} />

      <Button
        fullWidth
        disabled={isCompleteStripeSetupLoading}
        onClick={onCompleteStripeSetupClick}
      >
        {isCompleteStripeSetupLoading ? <LoadingSpinner size="small" /> : "Complete Stripe setup"}
      </Button>
    </Stack>
  );
}
